import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import {
  DataTableModule, SharedModule, ButtonModule, GrowlModule, InputTextModule, ConfirmDialogModule,
  DropdownModule, ChartModule, TabViewModule
} from 'primeng/primeng';

import { OrderRoutingModule } from './order-routing.module';
import { OrderComponent } from './order.component';
import { OrderDetailComponent } from '../order-detail/order-detail.component';
import { OrderService } from './order.service';

import { StockModule } from '../stock/stock.module';

@NgModule({
  imports: [
    CommonModule,
    OrderRoutingModule,
    FormsModule,
    DataTableModule, SharedModule,
    ButtonModule, GrowlModule, InputTextModule, ConfirmDialogModule,
    DropdownModule, ChartModule, TabViewModule, StockModule
  ],
  declarations: [OrderComponent, OrderDetailComponent],
  providers: [OrderService]
})
export class OrderModule { }



// WEBPACK FOOTER //
// /home/pneuser/workspace/pepelogistic/pepeLogisticControl/src/app/order/order.module.ts